import React, { useState } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import * as s from './styled-carousel';

const defaultResponsive = {
  size1: {
    breakpoint: { max: 660, min: 0 },
    items: 4,
  },
  size2: {
    breakpoint: { max: 757, min: 661 },
    items: 4,
  },
  size3: {
    breakpoint: { max: 854, min: 758 },
    items: 4,
  },
  size4: {
    breakpoint: { max: 950, min: 855 },
    items: 4,
  },
  size5: {
    breakpoint: { max: 1046, min: 951 },
    items: 4,
  },
  size6: {
    breakpoint: { max: 1143, min: 1047 },
    items: 4,
  },
  size7: {
    breakpoint: { max: 1239, min: 1144 },
    items: 4,
  },
  size8: {
    breakpoint: { max: 1336, min: 1240 },
    items: 4,
  },
  size9: {
    breakpoint: { max: 4000, min: 1337 },
    items: 4,
  },
};

export default ({
  infinite,
  responsive,
  swipeable,
  draggable,
  centerMode,
  children,
  partialVisible,
  afterChange,
  // hideArrows: oculta as setas de navegacao (ex.: quando ha so 1 item
  // nao faz sentido navegar). Default false pra nao mudar usos antigos.
  hideArrows,
}) => {
  const [carouselRef, setCarouselRef] = useState();

  return (
    <s.Container>
      {!hideArrows && (
        <s.ArrowContainer
          onClick={(e) => {
            e.stopPropagation();
            carouselRef.previous();
            afterChange && afterChange('left');
          }}
        >
          <button
            type="button"
            aria-label="left-arrow"
            className="custom-left-arrow carousel-arrow"
          />
        </s.ArrowContainer>
      )}
      <Carousel
        shouldResetAutoplay={false}
        containerClass="carousel-container-custom-class"
        infinite={infinite}
        ref={(e) => setCarouselRef(e)}
        responsive={responsive || defaultResponsive}
        slidesToSlide={1}
        swipeable={swipeable || false}
        draggable={draggable || false}
        keyBoardControl={false}
        transitionDuration={500}
        renderButtonGroupOutside
        centerMode={centerMode || false}
        arrows={false}
        partialVisible={partialVisible || false}
      >
        {children}
      </Carousel>
      {!hideArrows && (
        <s.ArrowContainer
          onClick={(e) => {
            e.stopPropagation();
            carouselRef.next();
            afterChange && afterChange('right');
          }}
        >
          <button
            type="button"
            aria-label="right-arrow"
            className="custom-right-arrow carousel-arrow"
          />
        </s.ArrowContainer>
      )}
    </s.Container>
  );
};
